/**
 * "We see your website is on HubSpot." The first thing confirmed.
 *
 * One component, because it appears on the reading screen and again above
 * the sign-up, and the person has to recognise it as the same fact both
 * times. It is the Proof card with HubSpot's own mark in HubSpot's own
 * colour: a supplied brand object keeps its colour (the Mark Is Not
 * Interface rule), so the orange lives in one token and is never a fill.
 * The mark is decorative; the words beside it already say what it means.
 * The mark is the only picture on it: a tick beside it was a second icon
 * saying the same thing.
 */
import HubSpotIcon from '@/components/icons/HubSpotIcon'
/* The Proof card's rules live in components.css; the mark's disc in onboarding.css. */
import '@/design-system/components.css'
import '@/design-system/onboarding.css'

export function HubSpotFound({ domain, testId = 'hubspot-found' }: { domain?: string; testId?: string }) {
  return (
    <div className="ds-proof ds-hsfound" role="status" data-testid={testId}>
      <span className="ds-hsfound__mark" aria-hidden="true">
        <HubSpotIcon />
      </span>
      <span>
        <div className="ds-proof__title">
          {domain ? (
            <>
              We see <b>{domain}</b> is on HubSpot.
            </>
          ) : (
            'We see your website is on HubSpot.'
          )}
        </div>
        <div className="ds-proof__detail">You are in the right place.</div>
      </span>
    </div>
  )
}
